// Module
var code = "D&ND Home";
// Exports
module.exports = code;